import React from "react"
import { Icon as LegacyIcon } from "@ant-design/compatible"
import { view } from "@risingstack/react-easy-state"

const FormIcon = ({ type }) => <LegacyIcon type={type} style={{ color: "rgba(0,0,0,.25)" }} />

export default view(FormIcon)
